import Builder from "./components/Builder"
import Render from "./components/Render"
import Properties from "./components/Properties"

let module = "checklist"

export default [
  {
    path: "checklist/properties",
    component: Properties,
    props: true,
    meta: { module: module, permissions: ["checklisttemplate-access"] }
  },
  {
    path: "checklist/builder",
    component: Builder,
    props: true,
    meta: { module: module, permissions: ["checklisttemplate-access"] }
  },
  {
    path: "checklist/render/:checklistid/form/:formid/order/:orderid/inspection/:inspectionid",
    component: Render,
    props: true,
    meta: { module: module, permissions: ["checklisttemplate-access"] }
  },
  {
    path: "checklist/render/:checklistid/form/:formid/equipment/:equipmentId/inspection/:inspectionid",
    component: Render,
    props: true,
    meta: { module: module, permissions: ["checklisttemplate-access"] }
  }
]
